<div class="stats-section">
    <div class="container">
      <div class="stats-grid">
        <!-- Users Stat -->
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-users"></i>
            <div class="icon-bg"></div>
          </div>
          <div class="stat-content">
            <h3 class="stat-count" data-count="200">600</h3>
            <p class="stat-label">مستخدمين</p>
          </div>
          <div class="stat-decoration"></div>
        </div>
  
        <!-- Happy Clients Stat -->
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-heart"></i>
            <div class="icon-bg"></div>
          </div>
          <div class="stat-content">
            <h3 class="stat-count" data-count="190">600</h3>
            <p class="stat-label">عملاء راضون</p>
          </div>
          <div class="stat-decoration"></div>
        </div>
  
        <!-- Reviews Stat -->
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-star"></i>
            <div class="icon-bg"></div>
          </div>
          <div class="stat-content">
            <h3 class="stat-count" data-count="250">40</h3>
            <p class="stat-label">تعليقات</p>
          </div>
          <div class="stat-decoration"></div>
        </div>
  
        <!-- Downloads Stat -->
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-download"></i>
            <div class="icon-bg"></div>
          </div>
          <div class="stat-content">
            <h3 class="stat-count" data-count="200">2K</h3>
            <p class="stat-label">تنزيلات التطبيق</p>
          </div>
          <div class="stat-decoration"></div>
        </div>
      </div>
    </div>
  </div>